/**
 * @file ScrollTop.tsx
 * @module _admin/layout/components/scroll-top/ScrollTop
 * @description Renders and exports the ScrollTop control for returning users to the top of long pages.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.5
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ScrollTopComponent,
  DrawerComponent,
  ToggleComponent,
  StickyComponent,
} from '../../../assets/ts/components';
import { ArrowUp } from 'lucide-react';
export function ScrollTop() {
  const { pathname } = useLocation();
  const isFirstRun = useRef(true);
  const pluginsReinitialization = () => {
    setTimeout(() => {
      StickyComponent.reInitialization();
      setTimeout(() => {
        ToggleComponent.reinitialization();
        DrawerComponent.reinitialization();
      }, 70);
    }, 140);
  };
  const scrollTop = () => {
    ScrollTopComponent.goTop();
  };
  const updateHeaderSticky = () => {
    const stickyHeader = document.body.querySelectorAll(
      `[data-kt-sticky-name="header"]`
    );
    if (stickyHeader && stickyHeader.length > 0) {
      const sticky = StickyComponent.getInstance(
        stickyHeader[0] as HTMLElement
      );
      if (sticky) {
        sticky.update();
      }
    }
  };
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else {
      pluginsReinitialization();
    }
    updateHeaderSticky();
    setTimeout(() => {
      scrollTop();
    }, 0);
  }, [pathname]);
  return (
    <div
      id="kt_scrolltop"
      className="scrolltop"
      data-kt-scrolltop="true"
    >
      <span className="svg-icon">
        <ArrowUp />
      </span>
    </div>
  );
}
